$(function () {
    function registerFilter(item) {
        var level = $('#level')[0].selectedOptions[0].attributes[0].value;
        var city = $('#departments')[0].selectedOptions[0].attributes[0].value;
        var form = $('#studyForm')[0].selectedOptions[0].attributes[0].value;
        var language = $('#lectureLanguage')[0].selectedOptions[0].attributes[0].value;
        var data = {
            filter: {
                product: $('#products').val(),
                level: level,
                city: city,
                form: form,
                language: language,
                dir: $('#dir').val(),
            },
        };

        $('.loading-contenerRight').show();

        $.ajax({
            url: $('#routeUrlEdu').data('route'),
            method: 'GET',
            data: data,
            dataType: 'json',
        }).done(function (response) {
            if (item === 'level') {
                $('#level option:not(:first)').remove();
                var levelCount = Object.keys(response.level).length;
                $.each(response.level, function (key, value) {
                    $('#level').append(new Option(value, key, false, levelCount === 1));
                });
                $('#level').change();
                dselect(document.querySelector('#level'));
            }

            if (item === 'department') {
                $('#departments option:not(:first)').remove();
                var cityCount = Object.keys(response.cities).length;
                $.each(response.cities, function (key, value) {
                    var selected = cityCount === 1 || String(key) === String($('#dirdep').data('dep'));
                    $('#departments').append(new Option(value, key, false, selected));
                });
                $('#departments').change();
                dselect(document.querySelector('#departments'));
            }

            if (item === 'studyForm') {
                $('#studyForm option:not(:first)').remove();
                var formCount = Object.keys(response.studyForm).length;
                $.each(response.studyForm, function (key, value) {
                    $('#studyForm').append(new Option(value, key, false, formCount === 1));
                });
                $('#studyForm').change();
                dselect(document.querySelector('#studyForm'));
            }

            if (item === 'lectureLanguage') {
                $('#lectureLanguage option:not(:first)').remove();
                var languageCount = Object.keys(response.lectureLanguage).length;
                $.each(response.lectureLanguage, function (key, value) {
                    $('#lectureLanguage').append(new Option(value, key, false, languageCount === 1));
                });
                $('#lectureLanguage').change();
                dselect(document.querySelector('#lectureLanguage'));
            }

            if (item === 'education') {
                $('#education option:not(:first)').remove();
                var educationCount = Object.keys(response.education).length;
                $.each(response.education, function (key, value) {
                    var label = value.title + ' (' + value.education_level.title + ')';
                    $('#education').append(new Option(label, value.id, false, educationCount === 1));
                });
                dselect(document.querySelector('#education'));
            }
        }).fail(function () {
            var toastElement = document.getElementById('liveToast');
            if (toastElement) {
                new bootstrap.Toast(toastElement).show();
            }
        }).always(function () {
            $('.loading-contenerRight').hide();
        });
    }

    if ($('#level').length > 0) {
        dselect(document.querySelector('#departments'));
        dselect(document.querySelector('#level'));
        dselect(document.querySelector('#products'));
        dselect(document.querySelector('#studyForm'));
        dselect(document.querySelector('#lectureLanguage'));
        dselect(document.querySelector('#education'));
        dselect(document.querySelector('#citizenshipId'));
        dselect(document.querySelector('#passportCountryId'));

        $('#createAccount').prop('checked', false).on('click', function () {
            $('.hiddeField').hide();

            if ($(this).is(':checked')) {
                $('.hiddeFieldP').show();
                $('#add-user-form').attr(
                    'data-action',
                    $('#add-user-form').attr('data-action').replace('registerStudent', 'registerStudentNew')
                );
            } else {
                $('.hiddeFieldP').hide();
                $('.hiddeField').show();
                $('#add-user-form').attr(
                    'data-action',
                    $('#add-user-form').attr('data-action').replace('registerStudentNew', 'registerStudent')
                );
            }
        });

        function updateIdentityFields() {
            var hasPolishCitizenship = String($('#citizenshipId').val()) === '139';
            var hasCitizenship = $('#citizenshipId').val() !== '';

            if (hasPolishCitizenship || !hasCitizenship) {
                $('#pesel').prop('required', true);
                $('#passportCountryId').val('').prop('required', false);
                $('#passport').val('').prop('required', false);
                $('.peselBlock').show();
                $('.passportBlock').hide();
            } else {
                $('#pesel').prop('required', false);
                $('#passportCountryId').prop('required', true);
                $('#passport').prop('required', true);
                $('.peselBlock').hide();
                $('.passportBlock').show();
            }
        }

        updateIdentityFields();
        $('#citizenshipId').change(updateIdentityFields);
        $('.disabled button').addClass('disabled');

        $('#products').change(function () {
            $('.level .dselect-clear, .department .dselect-clear, .studyForm .dselect-clear, .lectureLanguage .dselect-clear, .education .dselect-clear').click();
            $('.disabled.level button').toggleClass('disabled', $('#products').val() === '');
            if ($('#products').val() !== '') {
                registerFilter('level');
            }
        });

        $('#products').change();
        dselect(document.querySelector('#products'));

        $('#level').change(function () {
            $('.department .dselect-clear, .studyForm .dselect-clear, .lectureLanguage .dselect-clear, .education .dselect-clear').click();
            var selected = $(this).val() !== '';
            $('.disabled.department button').toggleClass('disabled', !selected);
            if (selected) {
                registerFilter('department');
            }
        });

        $('#departments').change(function () {
            $('.studyForm .dselect-clear, .lectureLanguage .dselect-clear, .education .dselect-clear').click();
            var selected = $(this).val() !== '';
            $('.disabled.studyForm button').toggleClass('disabled', !selected);
            if (selected) {
                registerFilter('studyForm');
            }
        });

        $('#studyForm').change(function () {
            $('.lectureLanguage .dselect-clear, .education .dselect-clear').click();
            var selected = $(this).val() !== '';
            $('.disabled.lectureLanguage button').toggleClass('disabled', !selected);
            if (selected) {
                registerFilter('lectureLanguage');
            }
        });

        $('#lectureLanguage').change(function () {
            $('.education .dselect-clear').click();
            var selected = $(this).val() !== '';
            $('.disabled.education button').toggleClass('disabled', !selected);
            if (selected) {
                registerFilter('education');
            }
        });
    }

    $('#add-user-form').on('submit', function (event) {
        event.preventDefault();

        var form = this;
        $('.loading-contenerAll').show();

        $.ajax({
            url: $(form).attr('data-action'),
            method: 'POST',
            data: new FormData(form),
            dataType: 'json',
            contentType: false,
            cache: false,
            processData: false,
        }).done(function () {
            var modalElement = document.getElementById('exampleModal');
            if (modalElement) {
                new bootstrap.Modal(modalElement).show();
            }
        }).fail(function (response) {
            var message = response.responseJSON && typeof response.responseJSON.message === 'string'
                ? response.responseJSON.message
                : $('#liveToastError .toast-body').text();

            $('#liveToastError .toast-body').text(message);
            var toastElement = document.getElementById('liveToastError');
            if (toastElement) {
                new bootstrap.Toast(toastElement).show();
            }
        }).always(function () {
            $('.loading-contenerAll').hide();
        });
    });
});
